import type { Channel } from '../types'

export interface State {
  businessActiveByIdentifier: Record<string, boolean>
  byId: Record<Channel['encoded_id'], Channel>
  requested: Record<string, true>
}

/**
 * Global state for channels
 */
export function createState(): State {
  return {
    businessActiveByIdentifier: {},
    byId: {},
    requested: {},
  }
}
